import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/** Menor a 600px (típico móvil) */
export function useIsXs() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}

/** Menor a 900px (móvil + tablet) */
export function useIsSmDown() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}
